import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseManagementWorkRequestStatusComponent } from './case-management-work-request-status.component';

const routes: Routes = [{ path: '', component: CaseManagementWorkRequestStatusComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagementWorkRequestStatusRoutingModule { }
